<app-dialog-close-button class="close-button" [compact]="true" (closed)="close()"></app-dialog-close-button>
<div vng-dialog-title class="text-center">
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1078_39808)">
            <path
                d="M56.9821 58.0043C47.1889 65.9987 16.6104 65.9987 7.01714 58.0043C-2.77599 50.0099 -1.77671 15.8339 7.01714 6.84023C15.811 -2.15345 48.1882 -2.15345 56.9821 6.84023C65.7759 15.8339 66.7752 50.01 56.9821 58.0043Z"
                style="fill: var(--vng-color-primary-admin)" />
            <g opacity="0.2">
                <path
                    d="M32.1996 44.014C23.4058 51.0091 13.6126 54.6066 4.41912 54.8064C-2.37616 43.2146 -0.977086 15.0344 7.01731 6.84021C14.2123 -0.554563 36.7964 -1.95364 49.7873 2.64311C52.985 15.8339 46.3897 32.622 32.1996 44.014Z"
                    fill="white" />
            </g>
            <path
                d="M27.4031 49.81C26.004 49.81 24.6051 49.2104 23.8056 48.0113L12.6135 33.6214C11.0146 31.6228 11.4144 28.8248 13.413 27.2259C15.4115 25.627 18.2096 26.0268 19.8085 28.0254L27.4031 37.8185L44.1913 16.0338C45.7902 14.0353 48.5882 13.6355 50.5868 15.2344C52.5854 16.8333 52.9852 19.6313 51.3863 21.6299L31.0005 48.0113C30.0013 49.0106 28.8021 49.81 27.4031 49.81Z"
                fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_1078_39808">
                <rect width="64" height="64" fill="white" />
            </clipPath>
        </defs>
    </svg>
</div>
<h2 vng-dialog-title class="text-center">
    Subscription paused
</h2>

<vng-dialog-content class="text-center mb-small">
    While your billing is paused, you will not lose any of your FlyMSGs.
</vng-dialog-content>

<hr>

<vng-dialog-actions align="center" class="top-space margin-gap" style="display:flex; justify-content:center; align-items:center; gap:15px">
    <button (click)="close()" vng-button variant="primary">
        Go Back to Subscription Details
    </button>
</vng-dialog-actions>
